module.exports = __webpack_public_path__ + "img/empreendimento-logo-15.fb627f53.png";